import React from 'react'
import { useAssessmentsValue } from '@LTIDashboard/state'
import { Header } from '@LTIDashboard/modules/common'

import {
  LoadingSpinner,
  getLoadingSpinnerProps,
} from '@LTIDashboard/modules/common/LoadingSpinner'
import { Assessments } from '@LTIDashboard/modules/GeneralDashboard/Assessments'

export function AssessmentsController() {
  const { assessments, request } = useAssessmentsValue()
  const AssessmentComponent = {
    loading: {
      headerProps: { hideIcon: true },
      Component: LoadingSpinner,
      componentProps: getLoadingSpinnerProps(),
    },
    loaded: {
      headerProps: { hideIcon: true },
      Component: Assessments,
      componentProps: { assessments },
    },
  }
  const { headerProps, Component, componentProps } =
    AssessmentComponent[request]

  return (
    <div className="border rounded card-myed p-3 mt-4">
      <Header title="Assessments" {...headerProps} />
      <Component {...componentProps} />
    </div>
  )
}
